import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Button, ButtonProps } from '@mui/material';
import { getTenantIdentifier } from '@utils/getTenantIdentifier';
import React from 'react';
import { useIntl } from 'react-intl';

export const SignOutButton: React.FC<ButtonProps> = (props) => {
  const { formatMessage } = useIntl();
  const tenantId = getTenantIdentifier();

  return (
    <form action={`/${tenantId}/api/Account/ExternalSignOut`} method='POST'>
      <Button
        variant="outlined"
        color="primary"
        disabled={false}
        startIcon={<ExitToAppIcon />}
        type='submit'
        {...props}
      >
        {formatMessage({ id: 'Sign out' })}
      </Button>
    </form>
  );
};


